__webpack_require__.p = "https://bpmrat.bpglobal.com/";